import { useEffect } from "react";
import { useLocation } from "wouter";

function scrollToHashTarget() {
  const raw = window.location.hash.slice(1);
  if (!raw) return false;
  const id = decodeURIComponent(raw);
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}

function scrollWindowToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/** Reset scroll on client-side navigation (footer/header links, etc.). */
export function ScrollToTop() {
  const [pathname] = useLocation();

  useEffect(() => {
    if (window.location.hash) {
      const timer = window.setTimeout(() => {
        if (!scrollToHashTarget()) scrollWindowToTop();
      }, 0);
      return () => window.clearTimeout(timer);
    }
    scrollWindowToTop();
  }, [pathname]);

  useEffect(() => {
    const onHashChange = () => {
      if (window.location.hash) scrollToHashTarget();
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return null;
}
